import clsx from "clsx";

import { Card } from "../../../../shared/card/card.tsx";
import { Select } from "../../../../ui/index.ts";
import type { SelectOption } from "../../../../ui/index.ts";
import type { Period, PeriodRange } from "../../../time-allocated-overview/types.ts";
import { PeriodRangeControl } from "../../../time-allocated-overview/components/period-range-control/period-range-control.tsx";
import { PeriodSelector } from "../../../time-allocated-overview/components/period-selector/period-selector.tsx";

import styles from "./project-reports-toolbar.module.css";

export interface ProjectReportsToolbarProps {
  projectId: string;
  onProjectIdChange: (id: string) => void;
  projectOptions: SelectOption[];
  projectsLoading: boolean;
  projectsError: string | null;
  period: Period;
  onPeriodChange: (period: Period) => void;
  range: PeriodRange;
  onRangeChange: (range: PeriodRange) => void;
}

export function ProjectReportsToolbar({
  projectId,
  onProjectIdChange,
  projectOptions,
  projectsLoading,
  projectsError,
  period,
  onPeriodChange,
  range,
  onRangeChange,
}: ProjectReportsToolbarProps) {
  return (
    <Card padding="3xl" className={styles.card}>
      <div className={styles.grid}>
        <div className={styles.fieldProject}>
          <Select
            label="Project Name"
            placeholder={projectsLoading ? "Loading..." : "Select Project Name"}
            searchable
            isClearable
            disabled={projectsLoading}
            value={projectId}
            onChange={onProjectIdChange}
            options={projectOptions}
          />
        </div>
        <div className={styles.fieldPeriod}>
          <span className={clsx("sub-heading-md", styles.periodLabel)}>
            View By
          </span>
          <PeriodSelector
            value={period}
            onChange={onPeriodChange}
            disabled={projectsLoading}
          />
        </div>
        <div className={styles.fieldRange}>
          <PeriodRangeControl
            period={period}
            range={range}
            onChange={onRangeChange}
            disabled={projectsLoading}
          />
        </div>
      </div>
      {projectsError ? (
        <p className={styles.error} role="alert">
          {projectsError}
        </p>
      ) : null}
    </Card>
  );
}
